const getBlurHashComponents = (hash: string) => {
    const firstChar = hash[0];
    const firstCharValue =
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%*+,-.:;=?@[]^_{|}~'.indexOf(firstChar);
    if (firstCharValue === -1) {
        return {
            components_x: 1,
            components_y: 1,
            aspect_ratio: 1,
        };
    }
    const components_x = (firstCharValue % 9) + 1;
    const components_y = Math.floor(firstCharValue / 9) + 1;

    return {
        components_x,
        components_y,
        aspect_ratio: components_x / components_y,
    };
};

export default getBlurHashComponents;
